import './sentry';
import './styles/global.css';

import ReactDOM from 'react-dom/client';

import App from './App';
import { exposeAppVersion } from './shared/app-version';

exposeAppVersion();

ReactDOM.createRoot(document.getElementById('mainNode') as HTMLElement).render(
  <App />,
);
